/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressApiModel } from './addressApiModel';


export interface EmployeeApiModel { 
    id: number;
    tenantEmployerId: number;
    employerId: number;
    addressId: number;
    titleBeforeName: string;
    name: string;
    surname: string;
    titleAfterName: string;
    dateOfBirth: string;
    age: number;
    inlineAddress: string;
    email: string;
    phoneNumber: string;
    birthNumber: string;
    personalNumber?: string | null;
    active: boolean;
    hasEntryExamination: boolean;
    address: AddressApiModel;
}

